import { RouterProvider } from 'react-router-dom'
import { router } from './route/route-config'
import { useAuth } from '@/hooks/use-auth'
import { useRaysync } from '@/hooks/use-raysync'
import { Modal } from 'task-eva-ui'
import { useModalStore } from '@/store/modal/modal-store'
import { css } from 'styled-components'
import { useResponseInterceptor } from './hooks/use-response-interceptor'
import { useSaveUserkey } from 'project-config/hooks'

function App() {
  useSaveUserkey()
  const getModalProps = useModalStore((state) => state.getModalProps())
  useResponseInterceptor()
  useAuth()
  useRaysync()
  return (
    <>
      <RouterProvider router={router} />
      <Modal
        {...getModalProps}
        customCSS={css`
          z-index: 2004;
        `}
      />
    </>
  )
}

export default App
